import { useRef, useCallback } from "react";

type Colors = string[];

interface IColorStackHook {
    reset: () => void;
    acquire: () => string;
    release: (color: string) => void;
}

export const useColorStack = (colors: Colors): IColorStackHook => {
    const colorsRef = useRef<Colors>([...colors]);
    const availableRef = useRef<Colors>([...colors]);

    const reset = useCallback(() => {
        availableRef.current = [...colorsRef.current];
    }, []);

    const acquire = useCallback(() => {
        if (!availableRef.current.length) {
            reset();
        }

        return availableRef.current.shift()!;
    }, [reset]);

    const release = useCallback((color: string) => {
        if (availableRef.current.includes(color)) {
            return;
        }

        const originalIndex = colorsRef.current.indexOf(color);
        const insertIndex = availableRef.current.findIndex((c) => colorsRef.current.indexOf(c) > originalIndex);

        if (insertIndex === -1) {
            availableRef.current.push(color);
        } else {
            availableRef.current.splice(insertIndex, 0, color);
        }
    }, []);

    return { reset, acquire, release };
};
